import { DateTime } from "luxon";
import { createFleetBooking, createVehicleBooking } from "../../../utils/axios-requests";
import { BookingStrategyContext } from "./bookingStrategies";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { runBookingWriteWithCancelConfirm } from "./runBookingWriteWithCancelConfirm.function";

/**
 * Builds fleet booking start/end as ISO strings.
 * When allDay is true (e.g. daily frequency, interval 1), uses full date range:
 * start = start of startDate, end = end of endDate.
 * TODO: check if this is correct
 */
export function fleetBookingStartEnd(
  startDate: string | null,
  endDate: string | null,
  startTime: string | null,
  endTime: string | null,
  allDay?: boolean
): { start: string; end: string } {
  if (allDay && startDate && endDate) {
    const start = DateTime.fromISO(startDate).startOf("day").toISO();
    const end = DateTime.fromISO(endDate).endOf("day").toISO();
    return { start: start ?? startDate, end: end ?? endDate };
  }
  const start =
    startDate && startTime
      ? DateTime.fromISO(`${startDate}T${startTime}`).toISO() ?? `${startDate}T${startTime}`
      : "";
  const end =
    endDate && endTime
      ? DateTime.fromISO(`${endDate}T${endTime}`).toISO() ?? `${endDate}T${endTime}`
      : "";
  return { start, end };
}

export const vehicleBookingStrategy = (ctx: BookingStrategyContext) => {
  const vehicleId = ctx.inputs.bookedVehicle?.id ?? ctx.inputs.selectedLocation ?? 0;
  const locationInventoryId = ctx.inputs.selectedLocation ?? 0;

  const { startDate, endDate, startTime, endTime } = ctx.standardBookingTimes;

  const startDateStr = startDate ?? "";
  const endDateStr = endDate ?? "";
  const startTimeStr = startTime ?? "";
  const endTimeStr = endTime ?? "";

  const bookingForUserId = ctx.bookingForUserId ?? ctx.sub;
  const isOnBehalf = ctx.isFleetOrTenantAdmin && bookingForUserId && bookingForUserId !== ctx.sub;

  const buildPayload = (confirmCancelExistingBookings?: boolean) => ({
    users: [{ userId: bookingForUserId, bookingInventoryId: vehicleId }],
    startDate: startDateStr,
    endDate: endDateStr,
    startTime: startTimeStr,
    endTime: endTimeStr,
    bookingType: BookingType.VEHICLE as const,
    locationInventoryId,
    tripReason: ctx.inputs.tripReason ?? undefined,
    ...(confirmCancelExistingBookings ? { confirmCancelExistingBookings: true } : {})
  });

  const post = (confirmCancelExistingBookings?: boolean) => {
    const payload = buildPayload(confirmCancelExistingBookings);
    return isOnBehalf ? createFleetBooking(payload) : createVehicleBooking(payload);
  };

  runBookingWriteWithCancelConfirm(post, {
    onSuccess: () => {
      ctx.onSuccess();
      ctx.conferenceBookingUsers(
        ctx.conferenceInputs,
        ctx.inputs,
        ctx.conferenceBooking,
        ctx.sub,
        ctx.timezoneMobileWorking,
        ctx.onError
      );
    },
    onError: ctx.onError,
    onCancelExistingConfirmationRequired: ctx.onCancelExistingConfirmationRequired
  });
};
